import React, { useState } from "react";
import ReactModal from "react-modal";
import styled from "styled-components";
import Select, { components } from "react-select";
import { Spinner } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import cioEvent from "../../../assets/cio_icon.svg";
import {
  getAllReportCohorts,
  getRecoCohortsDropdownOptions,
  getReportCohorts,
} from "../../../actions/radminUploads";
import { useEffect } from "react";
import Creatable from "react-select/creatable";
import { ReactComponent as RemoveRecoIcon } from "../../../assets/FollowUpDeleteIcon.svg";
import { ReactComponent as RemoveRecoIconHover } from "../../../assets/delete-hover.svg";


ReactModal.setAppElement("#root");

const StyledModal = styled(ReactModal)`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  width: 560px !important;
  padding: 18px 24px !important;
  // height: fit-content !important;
  height: 480px;

  margin: 8% auto;
  background: white;

  @media (max-width: 768px) {
    width: auto !important;
    margin: 30px !important;
    margin-top: calc(15% + 30px) !important;
  }
`;

const Remove = styled.div`
  cursor: pointer;
  margin-top: 30px;
`;

const IconContainer = styled.span`
  position: relative;
  cursor: pointer;
  display: inline-block;
  width: 30px;
  height: 20px;

  &:hover svg:not(.light) {
    display: none;
  }

  &:hover svg.light {
    display: block;
  }

  svg {
    position: absolute;
    top: 0;
    left: 0;
  }

  svg.light {
    display: none;
  }
`;

const CheckBoxLabel = styled.label`
  display: flex;
  gap: 10px;
  align-items: center;
  margin-top: 15px;
`;

const CheckboxTitle = styled.span`
  font-style: normal;
  font-weight: 700;
  font-size: 14px;
  line-height: 17px;
  color: #6d6e6e;
  text-align: left;
  text-transform: uppercase;
`;

const Label = styled.label`
  align-self: flex-start;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 19px;
  color: #6d6e6e;
`;

const Input = styled.input.attrs({ type: "text" })`
  width: 10%;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #c2ccd9;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 18px;
  color: #8692a4;
  height: 38px;
`;

const ButtonContainer = styled.div`
  display: flex;
  align-items: center;
  margin-top: 20px;
  justify-content: flex-end;
  gap: 10px;
`;

export const Image = styled.img`
  width: 20px;
  margin-left: 7px;
  color: #000000;
  fill: #000000;
`;

const Button = styled.button`
  width: 140px;
  height: 38px;
  background: ${({ isPrimary, disabled }) =>
    disabled ? "#00AEEF4D" : isPrimary ? "#00AEEF" : "transparent"};
  border-radius: 5px;
  border: ${({ isPrimary, disabled, color }) =>
    disabled
      ? "2px solid transparent"
      : isPrimary
      ? "2px solid #00AEEF"
      : `2px solid ${color ? color : "#CFCFCF"}`};
  outline: none !important;
  font-family: Roboto Condensed;
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
  color: ${({ isPrimary, color }) =>
    isPrimary ? "white" : color ?? "#000000"};
  &:hover {
    background: ${({ isPrimary, color }) =>
      isPrimary ? "transparent" : color ?? "#CFCFCF"};
    color: ${({ isPrimary }) => (isPrimary ? "#00aeef" : "white")};
    border: ${({ isPrimary, disabled, color }) =>
      isPrimary
        ? "2px solid #00AEEF"
        : `2px solid ${color ? color : "#CFCFCF"}`};
  }
`;

const customStyle = {
  overlay: {
    backdropFilter: "blur(10px)",
    backgroundColor: "rgba(12, 41, 69, 0.38)",
    zIndex: 1,
  },
  content: {
    borderRadius: "4px",
  },
};

const IndicatorsContainer = (props) => {
  return (
    <div style={{ backgroundColor: "#FFF" }}>
      <components.IndicatorsContainer {...props} />
    </div>
  );
};
const colourStyles = {
  placeholder: (styles) => ({ ...styles, fontSize: "14px" }),
  control: (styles) => ({ ...styles, backgroundColor: "white" }),
  option: (styles, { isDisabled, isSelected }) => {
    return {
      ...styles,
      fontSize: "14px",
      color: "black",
      cursor: isDisabled ? "not-allowed" : "default",
      backgroundColor: isSelected ? "#D9ECFF" : "white",
      display: "flex",
    };
  },
  multiValue: (styles, { data }) => ({
    ...styles,
    borderRadius: "25px",
    backgroundColor: "#EEEEEE",
    color: "#A1A1A1",
    padding: "4px 10px",
  }),
  multiValueLabel: (styles, { data }) => ({
    ...styles,
    color: "#A1A1A1",
    fontSize: "10px",
  }),
};

const ConversionTrackingModal = ({
  headerTitle = "",
  inputTitle = "",
  placeholderText = "",
  onClose,
  onSave,
  opened,
  inputValue,
  setInputValue,
  showDropDown,
  isChecked,
  setIsChecked,
}) => {
  const [loading, setLoading] = useState(false);
  const [savedCohortGroups, setSavedCohortGroups] = useState();
  const dispatch = useDispatch();

  const [selectedGroup, setSelectedGroup] = useState();
  const [days, setDays] = useState();
  const [fields, setFields] = useState([
    { id: Date.now(), initialModality: null, subsequentModality: null },
  ]);

  const hasReportSearchEventsEnabled = useSelector(
    (state) => state.auth.user.provider.report_search_event
  );

  const RadioOption = (props) => {
    return (
      <>
        <components.Option {...props}>
          <div style={{ display: "flex", gap: "5px" }}>
            <span>
              <input
                type="radio"
                checked={props.isSelected}
                onChange={() => null}
                style={{ marginTop: 5 }}
              />{" "}
            </span>
            <label>{props.label}</label>
            {props?.data?.trigger_cio_event && hasReportSearchEventsEnabled ? (
              <span>
                <Image src={cioEvent} alt={"settings icon"} />
              </span>
            ) : null}
          </div>
        </components.Option>
      </>
    );
  };

  const handleFilterSave = async (e) => {
    e.preventDefault();
    setLoading(true);

    onSave(days);
    setLoading(false);
  };


  useEffect(() => {
    dispatch(getAllReportCohorts()).then((res) => {
      if (res) {
        setSavedCohortGroups(
          res?.results?.map((itm) => ({
            ...itm,
            label: itm.title,
            value: itm.id,
          }))
        );
      }
    });
  }, []);

  const handleAddMore = () => {
    setFields([
      ...fields,
      { id: Date.now(), initialModality: null, subsequentModality: null },
    ]);
  };

  const handleRemove = (id) => {
    setFields(fields.filter((f) => f.id !== id));
  };

  const handleChange = (id, type, selectedOption) => {
    setFields((prev) =>
      prev.map((item) =>
        item.id === id ? { ...item, [type]: selectedOption } : item
      )
    );
  };

  return (
    <StyledModal
      style={customStyle}
      isOpen={opened}
      onRequestClose={onClose}
      contentLabel="Save Filter Set"
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          width: "100%",
        }}
      >
        <div
          style={{
            fontSize: "24px",
            color: "#0C2945",
            fontWeight: 700,
            fontFamily: "Roboto Condensed",
          }}
        >
          <h3 style={{ fontWeight: "bold" }}>Conversion Tracking</h3>
        </div>
        <p style={{ cursor: "pointer" }} onClick={onClose}>
          x
        </p>
      </div>
      <div
        style={{
          fontSize: "20px",
          color: "#0C2945",
          fontWeight: "bold",
          fontFamily: "Roboto Condensed",
        }}
      >
        <p>
          Please indicate how you'd like to track the conversion and success
        </p>
      </div>
      <form style={{ width: "100%" }} onSubmit={handleFilterSave}>
        <div style={{overflowY: 'auto', height: '230px'}}>
          <>
            <div>
              <Label children={inputTitle} htmlFor="filterSet" />
              <br />
              <Input
                min={0}
                max={450}
                onChange={(e) => {
                  const value = Number(e.target.value);
                  if (value >= 0 && value <= 450) {
                    setDays(value);
                  } else if (e.target.value === "") {
                    setDays("");
                  }
                }}
                value={days}
                id="filterSet"
                placeholder={""}
              />
            </div>
            <div>
              {fields.map((field, index) => (
                <div
                  key={field.id}
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "10px",
                    alignItems: "center",
                    marginTop: "5px",
                  }}
                >
                  <div style={{ minWidth: "220px" }}>
                    <Label children="INITIAL MODALITY" />
                    <Creatable
                      isClearable={true}
                      onChange={(val) =>
                        handleChange(field.id, "initialModality", val)
                      }
                      options={savedCohortGroups}
                      // value={selectedGroup}
                      value={field.initialModality}
                      placeholder="Select..."
                      components={{
                        IndicatorsContainer,
                        Option: RadioOption,
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={{
                        option: (styles) => ({
                          ...styles,
                          fontSize: "14px",
                        }),
                      }}
                    />
                  </div>

                  <div style={{ minWidth: "220px" }}>
                    <Label children="SUBSEQUENT MODALITY" />
                    <Creatable
                      isClearable={true}
                      options={savedCohortGroups}
                      onChange={(val) =>
                        handleChange(field.id, "subsequentModality", val)
                      }
                      value={field.subsequentModality}
                      placeholder="Select..."
                      components={{
                        IndicatorsContainer,
                        Option: RadioOption,
                      }}
                      className="basic-multi-select"
                      classNamePrefix="select"
                      styles={{
                        option: (styles) => ({
                          ...styles,
                          fontSize: "14px",
                        }),
                      }}
                    />
                  </div>
                  {fields.length !== 1 && (
                    <Remove onClick={() => handleRemove(field.id)}>
                      <IconContainer>
                        <RemoveRecoIcon />
                        <RemoveRecoIconHover className="light" />
                      </IconContainer>
                    </Remove>
                  )}
                </div>
              ))}
            </div>
          </>
        </div>

        <ButtonContainer>
          <Button onClick={onClose} children="Cancel" />
          <Button onClick={handleAddMore} color="#00AEEF" children="Add More" />
          <Button
            type="submit"
            isPrimary={true}
            disabled={!days && !fields.initialModality}
            children={
              loading ? (
                <Spinner animation="border" role="status" size="sm" />
              ) : (
                "Save"
              )
            }
          />
        </ButtonContainer>
      </form>
    </StyledModal>
  );
};

export default ConversionTrackingModal;
